export default "__VITE_ASSET__b935b741__"